var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_23031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 29.2794C17.4836 29.2541 18.1016 29.2267 18.7196 29.1972C19.2386 26.4469 19.9577 23.7727 20.9275 21.2802C22.0234 18.5045 23.5057 15.9845 25.4636 14.3161C26.5889 13.2646 25.6601 10.9335 24.4168 11.6916C19.5655 14.861 16.4346 22.1448 14.6387 29.4266C15.382 29.3535 16.126 29.3099 16.8649 29.2784L16.8642 29.2794Z",
    fill: "#D1EAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8636 29.2795C17.0292 29.2724 17.1949 29.2653 17.3606 29.2582C17.7769 24.2315 18.7116 19.1916 20.4474 14.7292C21.5434 11.9535 23.0256 9.43355 24.9836 7.76509C26.1088 6.71368 25.18 4.3825 23.9368 5.14061C17.6149 9.27016 14.2114 20.3882 12.8802 29.3841C12.864 29.4795 12.853 29.5749 12.8442 29.6692C14.1784 29.4338 15.5287 29.3353 16.8636 29.2795V29.2795Z",
    fill: "#B5DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52627 8.16291C7.74815 7.36014 8.95328 10.6778 9.61376 13.1713C10.706 17.4826 11.0711 22.153 11.2712 26.7271C11.3115 27.7988 11.3401 28.9213 11.3416 30.0001C12.7908 29.6114 14.2752 29.4328 15.7516 29.3374C15.7106 28.8654 15.6578 28.3255 15.6219 27.9531C14.9137 21.4335 13.1441 7.99545 8.25175 5.2979C7.19323 4.69608 5.92138 4.75799 4.88338 5.29587C3.59908 5.99411 4.17965 8.59322 5.52627 8.16291Z",
    fill: "#D1EAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7112 19.5915C14.6495 13.2495 17.0488 5.41259 21.5057 2.5009C22.3825 1.96708 23.0371 3.61017 22.2439 4.35103C20.8636 5.52728 19.8182 7.30433 19.0463 9.26C17.8111 12.4345 17.1507 16.0252 16.8618 19.6016C16.8545 19.7082 16.8325 20.0187 16.8311 20.1182C16.8149 21.3249 16.0958 22.285 15.2249 22.2626C14.2331 22.2525 13.4913 20.923 13.7127 19.5915H13.7112Z",
    fill: "#D1EAAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_23031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant2);
export default __webpack_public_path__ + "static/media/plant-2.3f37602097535f9f9d55a7e01531eb29.svg";
export { ForwardRef as ReactComponent };